<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id
      }"
    />
    <div class="d-flex">
      <input
        :id="id"
        type="range"
        :value="value"
        :min="mergedConfig.min"
        :max="mergedConfig.max"
        :disabled="disabled"
        class="slider flex-1"
        @input="update($event.target.value)"
      />
      <small
        v-if="mergedConfig.showValue"
        class="form-range__value text-muted ml-2"
      >
        {{ value }}
      </small>
    </div>
  </div>
</template>

<script>
import FormMixin from './FormMixin'
import FormLabel from './FormLabel'

export default {
  name: 'FormRange',
  mixins: [ FormMixin ],
  components: { FormLabel },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    mergedConfig () {
      return {
        min: 0,
        max: 10,
        showValue: false,
        ...this.config,
      }
    },
  },
  methods: {
    update (value) {
      this.$emit('input', parseInt(value, 10))
    },
  },
}
</script>

<style scoped>
.form-range__value {
  width: 50px;
}

.form-control {
  height: 36px;
}
</style>
